import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { postMessage } from "../../services/api";

import ChatHeader from "../../components/CommonComponents/ChatHeader";
import ChatSidebar from "../../components/CommonComponents/ChatSidebar";
import Disclaimer from "../../components/CommonComponents/Disclaimer";
import LoaderPage from "../../components/CommonComponents/Loader/LoaderPage";
import NewsURACPageProps from "../../components/CommonComponents/NewsURACPageProps";

import "../../images/css/contact.css";

interface NewsItem {
  title: string;
  content: string;
  url: string;
  image: string;
  date: string;
  author: string;
  max_page: number;
}

const NewsUpdatesPageOld: React.FC = () => {
  const [news, setNews] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [button, setButton] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [newsUrl, setNewsUrl] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [maxPage, setMaxPage] = useState<number>(1);

  useEffect(() => {
    document.title = "AskWellie | News & Update";

    fetchNews(currentPage);
  }, [currentPage]);

  const fetchNews = async (page_number: number): Promise<void> => {
    setLoading(true);

    try {
      const response = await postMessage("/api/news/urac", { page_number }, false);
      setNews(response.data as NewsItem[]);
      setMaxPage(response.data[0]?.max_page || 1);
      setError(false)
    }
    catch (error) {
      toast.error("Failed to load news. Please try again.", { position: "top-right", autoClose: 3000 });
      setError(true)
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ChatHeader />
      <div className="chat-row-container flex-columns columns-full">
        <ChatSidebar />
        <div className="chat-row-container flex-columns columns-full">
          <div className="max-w-4xl mx-auto p-6 right-content-wrapper h-100dvh">
            <div className="chat-title">
              <h1 style={{ textTransform: "capitalize" }}>News & Updates</h1>
            </div>
            <p>Stay up to date with the latest enhancements to AskWellie, new features, and health-related news. Our <b>News & Updates</b> section includes:</p>
            {loading ? (
              <LoaderPage />
            ) : (
              <div>
                <div className="news-wrapper grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 display-news">
                  {news.length > 0 ? (
                    news.map((item: NewsItem, index: number) => (
                      <div key={index} className="p-4 news-border rounded-md shadow-md bg-white news-wrapper-width">
                        <p className="text-gray-600 text-center">
                          {new Date(item?.date).toLocaleDateString("en-GB", { day: "2-digit" })}&nbsp;
                          <b>{new Date(item?.date).toLocaleDateString("en-GB", { month: "short" })}</b>&nbsp;
                          {new Date(item?.date).toLocaleDateString("en-GB", { year: "numeric" })}<br />
                          Posted In <b>{item?.author}</b>
                        </p>
                        <img src={item?.image} alt={item?.title} />
                        <h5 className="text-xll text-bold text-center font-semibold mt-4">
                          <b>
                            {item?.title.length > 50 ? item?.title.slice(0, 47).trim() + '...' : item?.title}
                          </b>
                        </h5>
                        <p className="text-m text-center mt-2">
                          {item?.content.length > 150 ? item?.content.slice(0, 147).trim() + '...' : item?.content}
                        </p>
                        <div className="pagination-center mt-6">
                          <div className="flex space-x-2">
                            <button onClick={() => { setButton(true); setNewsUrl(item?.url) }} className="px-4 py-2 text-white rounded-full mx-1">
                              Read More
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="loader-container-page">No news available.</p>
                  )}
                  {button && <NewsURACPageProps url={newsUrl} setButton={setButton} />}
                </div>
                <p>Check back regularly for updates on how AskWellie is evolving to serve you better.</p>

                {!error &&
                  <div className="pagination-center mt-6">
                    <div className="flex space-x-2">
                      {currentPage > 1 && (
                        <>
                          {currentPage > 3 && (<button className="px-4 py-1 text-white rounded-full mx-1" onClick={() => setCurrentPage(1)}>First</button>)}
                          <button className="px-4 py-1 text-white rounded-full mx-1" onClick={() => setCurrentPage(currentPage - 1)}>Previous</button>
                        </>
                      )}
                      {Array.from({ length: 5 }, (_, index) => {
                        const pageNum = currentPage - 2 + index;
                        if (pageNum < 1 || pageNum > maxPage) return null;
                        return (
                          <button key={pageNum} className={
                            `px-4 py-1 rounded-full mx-1 ${currentPage === pageNum ? "bg-secondary text-white cursor-not-allowed" : "text-white hover:bg-gray-400"}`}
                            disabled={currentPage === pageNum} onClick={() => setCurrentPage(pageNum)}>
                            {pageNum}
                          </button>
                        );
                      })}
                      {currentPage < maxPage ? (
                        <>
                          <button className="px-4 py-1 text-white rounded-full mx-1" onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
                          {currentPage < maxPage - 2 && (<button className="px-4 py-1 text-white rounded-full mx-1" onClick={() => setCurrentPage(maxPage)}>Last</button>)}
                        </>
                      ) : (
                        <button className="px-4 py-1 rounded-full mx-1 bg-secondary text-white cursor-not-allowed" disabled>{currentPage}</button>
                      )}
                    </div>
                  </div>}
              </div>

            )}
          </div>
        </div>
      </div>
      <Disclaimer />
    </div>
  );
};

export default NewsUpdatesPageOld;
